export enum Roles {
  Captain = "CAPTAIN",
  CaptainVice = "CAPTAIN_VICE",
  Ceo = "CEO",
  Coach = "COACH",
  CoachAssistant = "COACH_ASSISTANT",
  CoachAssistantHead = "COACH_ASSISTANT_HEAD",
  CoachAssociateHead = "COACH_ASSOCIATE_HEAD",
  CoachDevelopment = "COACH_DEVELOPMENT",
  CoachHead = "COACH_HEAD",
  CoachHeadInterim = "COACH_HEAD_INTERIM",
  CoachOther = "COACH_OTHER",
  CoachSc = "COACH_SC",
  CoachSenior = "COACH_SENIOR",
  CoachSpecialist = "COACH_SPECIALIST",
  Commissioner = "COMMISSIONER",
  Committee = "COMMITTEE",
  CrewChief = "CREW_CHIEF",
  Director = "DIRECTOR",
  Doctor = "DOCTOR",
  General = "GENERAL",
  Groundskeeper = "GROUNDSKEEPER",
  JudgeScoring = "JUDGE_SCORING",
  JudgeTiming = "JUDGE_TIMING",
  Manager = "MANAGER",
  MatchOfficial = "MATCH_OFFICIAL",
  MediaOfficer = "MEDIA_OFFICER",
  Other = "OTHER",
  Physiotherapist = "PHYSIOTHERAPIST",
  President = "PRESIDENT",
  PresidentVice = "PRESIDENT_VICE",
  Referee = "REFEREE",
  RefereeAssistant = "REFEREE_ASSISTANT",
  RefereeAssistantReserve = "REFEREE_ASSISTANT_RESERVE",
  RefereeReserve = "REFEREE_RESERVE",
  Scorer = "SCORER",
  HandballScorer = "SCOREKEEPER",
  ScorerAssistant = "SCORER_ASSISTANT",
  Secretary = "SECRETARY",
  ShotClockOperator = "SHOT_CLOCK_OPERATOR",
  Statistician = "STATISTICIAN",
  TechnicalOfficial = "TECHNICAL_OFFICIAL",
  Timer = "TIMER",
  Timekeeper = "TIMEKEEPER",
  Trainer = "TRAINER",
  TrainerAssistant = "TRAINER_ASSISTANT",
  Translator = "TRANSLATOR",
  Treasurer = "TREASURER",
  Umpire = "UMPIRE",
  Umpire1 = "UMPIRE_1",
  Umpire2 = "UMPIRE_2",
  UmpireReserve = "UMPIRE_RESERVE",
  UmpireVideo = "UMPIRE_VIDEO",
  VideoTechnician = "VIDEO_TECHNICIAN",
  Delegate = "DELEGATE",
  ScoutSupervisor = "SCOUT_SUPERVISOR",
  MatchSupervisor = "MATCH_SUPERVISOR",
  Scout1 = "SCOUT_1",
  Scout2 = "SCOUT_2",
  Scout3 = "SCOUT_3",
  RefereeObserver = "REFEREE_OBSERVER",
  AssistantReferee1 = "ASSISTANT_REFEREE_1",
  AssistantReferee2 = "ASSISTANT_REFEREE_2",
  MedicalStaff = "MEDICAL_STAFF",
  UmpireManager = "UMPIRE_MANAGER",
  TechnicalDelegate = "TECHNICAL_DELEGATE",
  TechnicalDelegateAssistant = "TECHNICAL_DELEGATE_ASSISTANT",
  OFFICIAL_A = "OFFICIAL_A",
  OFFICIAL_B = "OFFICIAL_B",
  OFFICIAL_C = "OFFICIAL_C",
  OFFICIAL_D = "OFFICIAL_D",
  OFFICIAL_E = "OFFICIAL_E",
  PhysicalTrainer = "PHYSICAL_TRAINER",
  Psychologist = "PSYCHOLOGIST",
  StandInManager = "STAND_IN_MANAGER",
  TeamLeader = "TEAM_LEADER",
  TeamManager = "TEAM_MANAGER",
  TeamMediaOfficer = "TEAM_MEDIA_OFFICER",
  VideoAnalyst = "VIDEO_ANALYST",
  TournamentAdministrator = "ADMINISTRATOR_TOURNAMENT",
  AppealJury = "APPEAL_JURY",
  AppealJuryPresident = "APPEAL_JURY_PRESIDENT",
  Judge = "JUDGE",
  MatchManager = "MATCH_MANAGER",
  MedicalOfficer = "MEDICAL_OFFICER",
  MedicalOfficerContinentalFederation = "MEDICAL_OFFICER_CF",
  MedicalOfficerFIH = "MEDICAL_OFFICER_FIH",
  NationalTournamentOfficial = "NATIONAL_TOURNAMENT_OFFICIAL",
  AssociationRepresentative = "REPRESENTATIVE_ASSOCIATION",
  ContinentalAssociationRepresentative = "REPRESENTATIVE_ASSOCIATION_CONTINENTAL",
  GoverningBodyAssociationRepresentative = "REPRESENTATIVE_ASSOCIATION_GOVERNING_BODY",
  IntercontinentalAssociationRepresentative = "REPRESENTATIVE_ASSOCIATION_INTERCONTINENTAL",
  InternationalAssociationRepresentative = "REPRESENTATIVE_ASSOCIATION_INTERNATIONAL",
  NationalAssociationRepresentative = "REPRESENTATIVE_ASSOCIATION_NATIONAL",
  RegionalAssociationRepresentative = "REPRESENTATIVE_ASSOCIATION_REGIONAL",
  ContinentalFederationRepresentative = "REPRESENTATIVE_CONTINENTAL_FEDERATION",
  FederationRepresentative = "REPRESENTATIVE_FEDERATION",
  GoverningBodyRepresentative = "REPRESENTATIVE_GOVERNING_BODY",
  IntercontinentalFederationRepresentative = "REPRESENTATIVE_INTERCONTINENTAL_FEDERATION",
  InternationalFederationRepresentative = "REPRESENTATIVE_INTERNATIONAL_FEDERATION",
  NationalFederationRepresentative = "REPRESENTATIVE_NATIONAL_FEDERATION",
  RegionalFederationRepresentative = "REPRESENTATIVE_REGIONAL_FEDERATION",
  TechnicalOfficer = "TECHNICAL_OFFICER",
  AssistantUmpireManager = "UMPIRE_ASSISTANT_MANAGER",
  NationalUmpire = "UMPIRE_NATIONAL",
  NeutralUmpire = "UMPIRE_NEUTRAL",
  ClubOfficial = "CLUB_OFFICIAL",
  SportingDirector = "SPORT_DIRECTOR",
  ClubOfficialAssistant = "CLUB_OFFICIAL_ASSISTANT",
  LiaisonOfficer = "LIAISON_OFFICER",
  YouthCoordinator = "YOUTH_COORDINATOR",
  MatchLiaison = "MATCH_LIAISON",
  OfficeStaff = "OFFICE_STAFF",
  PlayerContractManager = "PLAYER_CONTRACT_MANAGER",
  ClubITOfficer = "CLUB_IT_OFFICER",
  RefereeLiaison = "REFEREE_LIAISON",
  RefereeObserverLiaison = "REFEREE_OBSERVER_LIAISON",
  TeamCoordinator = "TEAM_COORDINATOR",
  GoalkeeperCoach = "COACH_GK",
}
